import { EventMap, getEventBusInstance } from '@/components/FlowSheetEditor/events/useEventBusInstance'
import { ChangeType } from '@/types/common'
import isObject from 'lodash/isObject'

export enum CustomCellType {
  Variable,
  Formula,
  VariableFormula
}
interface ICustomCellValue {
  t: CustomCellType
  v: any
  unitId?: string
  attrCode?: string
  formula?: string
}

function isCustomCell(value: any) {
  if (isObject(value)) {
    return true
  }

  return false;
}

export function updateCellView(cell: HTMLTableCellElement, value: any) {
  if (isCustomCell(value)) {
    const cellVal = value as ICustomCellValue
    let cellDivClassName = ''
    cell.classList.add('orbit-cell')
    let cellText = cellVal.v
    if (cellVal.t === CustomCellType.Variable) {
      cellDivClassName = `orbit-variable-cell`
      cell.classList.add('variable-cell')
      if (isObject(value.v)) {
        cellDivClassName = `${cellDivClassName} manual-var`
        cellText = cellVal.v.val
      }
    } else if (cellVal.t === CustomCellType.Formula) {
      cell.classList.add('formula-cell')
      cellDivClassName = `orbit-formula-cell`
      cellText = cellVal.v ?? cellVal.formula
    } else if (cellVal.t === CustomCellType.VariableFormula) {
      cell.classList.add('variable-cell', 'formula-cell')
      cellDivClassName = `orbit-variable-cell orbit-formula-cell`
      cellText = cellVal.v ?? cellVal.formula
    }
    // TODO: here may case a XSS issue
    cell.innerHTML = `<div class="orbit-cell-div ${cellDivClassName}">${cellText}</div>`
    return;
  }
  cell.innerHTML = value
}

 const createEditor = function(cell: HTMLTableCellElement, type: string) {
    // Cell information
    const info = cell.getBoundingClientRect();

    // Create dropdown
    const editor = document.createElement(type);
    editor.style.width = (info.width) + 'px';
    editor.style.height = (info.height - 2) + 'px';
    editor.style.minHeight = (info.height - 2) + 'px';

    // Edit cell
    cell.classList.add('editor');
    cell.innerHTML = '';
    cell.appendChild(editor);

    return editor;
}


export function CustomCellEditor() {
  const methods = {} as any;
  let editor: any = null;
  let editValue: any
  methods.createCell = function(cell, value, x, y, instance, options) {
    updateCellView(cell, value)
  }

  methods.openEditor = function(cell: HTMLTableCellElement, value: any, x: Number, y: Number, instance: any, options: any) {
    // const eventBus = getEventBusInstance()
    // eventBus.trigger(EventMap.editSpreadCell, {instance, x, y, cell, value})
    editValue = value
    if (isCustomCell(value)) {
      const cellVal = value.v;
      if (value.t === CustomCellType.Variable) {
        if (isObject(cellVal)) {
          editor = createEditor(cell, 'input')
          editor.value = cellVal.val;
        } else {
          editor = null
        }
      } else {
        editor = createEditor(cell, 'input')
        editor.value = value.formula ?? cellVal
      }
    } else {
      editor = createEditor(cell, 'input')
      editor.value = value
    }
    editor?.focus()
  }

  methods.closeEditor = function (cell, save, x, y, instance) {
    if (!editor) return editValue;
    const eventBus = getEventBusInstance()
    let oldValue: any = instance.getValueFromCoords(x, y)
    cell.classList.remove('editor');
    if (isCustomCell(oldValue)) {
      oldValue = copyData(oldValue)
      const cellVal = oldValue.v;
      if (oldValue.t === CustomCellType.Variable) {
        if (isObject(cellVal)) {
          const numVal = Number(editor.value)
          oldValue.v.val = isNaN(numVal) ? editor.value : numVal
        }
      } else {
        oldValue.formula = editor.value
      }
      setTimeout(() => {
        updateCellView(cell, oldValue)
        eventBus.trigger(EventMap.spreadCellChange, {payload: oldValue, type: ChangeType.Change})
      }, 50);
      return oldValue;
    }
    let newVal = editor.value
    
    if (newVal.toString().startsWith('=')) {
      newVal = {
        t: CustomCellType.Formula,
        v: undefined,
        formula: newVal
      }
    }
    updateCellView(cell, newVal)
    setTimeout(() => {
      eventBus.trigger(EventMap.spreadCellChange, {payload: newVal, type: ChangeType.Change})
    }, 50);
    return newVal
  }

  return methods;
}

function copyData(data) {
  return JSON.parse(JSON.stringify(data))
}
